import React, { Fragment, useEffect, useMemo, useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  DialogContentText,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

// import Backdrop from "Components/Common/Backdrop";
import Backdrop from "Components/Common/Backdrop";
import Modal from "Components/Common/Modal";
import FireSafetyViewBuildingInformationDetails from "./FireSafetyViewBuildingInformationDetails";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";
import { filterObjectForUpdateTracking } from "utils/filterEmptyObjectsForFireSafety";

import { useFloorQuery } from "apis/Floor";
import { useGetFireSafetyApplicationUpdateTrackingQuery } from "apis/FireSafety/FireApplicationDetail";

const FireSafetyBuildingInformationTracking = ({
  applicationId,
  handleClose,
}) => {
  const { data: { data: buildingInformationTrackingDetails } = {}, isLoading } =
    useGetFireSafetyApplicationUpdateTrackingQuery(applicationId);

  const { data: { data: floors } = {}, isLoading: isFloorsLoading } =
    useFloorQuery({}, true);

  const [selectedApplicationUpdateId, setSelectedApplicationUpdateId] =
    useState("");

  const filteredBuildingInformationTrackingDetails = useMemo(
    () =>
      buildingInformationTrackingDetails?.map((item) =>
        filterObjectForUpdateTracking(item)
      ),
    [buildingInformationTrackingDetails]
  );

  const selectedBuildingDetails = useMemo(() => {
    return (
      filteredBuildingInformationTrackingDetails?.find(
        ({ id }) => id === selectedApplicationUpdateId
      ) ?? {}
    );
  }, [filteredBuildingInformationTrackingDetails, selectedApplicationUpdateId]);

  const handleToggle = (id) => {
    if (selectedApplicationUpdateId === id) {
      setSelectedApplicationUpdateId("");
    } else {
      setSelectedApplicationUpdateId(id);
    }
  };

  useEffect(() => {
    if (buildingInformationTrackingDetails?.length === 1) {
      setSelectedApplicationUpdateId(buildingInformationTrackingDetails[0].id);
    }
  }, [buildingInformationTrackingDetails]);

  if (isLoading || isFloorsLoading) {
    return <Backdrop open />;
  }

  return (
    <Modal
      isOpen
      handleClose={handleClose}
      title="Building Information Details"
      maxWidth="lg"
    >
      {buildingInformationTrackingDetails?.length ? (
        buildingInformationTrackingDetails.map(({ id, timeStamp }) => (
          <Fragment key={id}>
            <div
              className="fs-4 fw-semibold mb-3 border-bottom"
              onClick={() => handleToggle(id)}
              key={id}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className="cursor-pointer"
              >
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center gap-1">
                    <p className="fw-bold mb-0">Updated At: </p>
                    <p className="fw-light fs-5 mb-0">
                      {convertUTCDateToLocalDate(timeStamp).format(
                        "DD-MM-YYYY HH:mm:ss A"
                      )}
                    </p>
                  </div>
                </div>
                <IconButton>
                  {selectedApplicationUpdateId === id ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </IconButton>
              </Stack>
            </div>
            <DialogContentText variant="subtitle2" component="div">
              <Collapse
                in={selectedApplicationUpdateId === id}
                timeout="auto"
                unmountOnExit
              >
                <>
                  {!!selectedBuildingDetails.oldBuildingInformation && (
                    <FireSafetyViewBuildingInformationDetails
                      applicationData={
                        selectedBuildingDetails.oldBuildingInformation
                      }
                      title="Old Building Information :"
                      floors={floors ?? []}
                    />
                  )}

                  {!!selectedBuildingDetails.newBuildingInformation && (
                    <FireSafetyViewBuildingInformationDetails
                      applicationData={
                        selectedBuildingDetails.newBuildingInformation
                      }
                      title="New Building Information :"
                      floors={floors ?? []}
                    />
                  )}
                </>
              </Collapse>
            </DialogContentText>
          </Fragment>
        ))
      ) : (
        <Typography variant="h6" className="text-center mt-3">
          This consumer's details has not been updated till now
        </Typography>
      )}
    </Modal>
  );
};

FireSafetyBuildingInformationTracking.propTypes = {
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
};

export default FireSafetyBuildingInformationTracking;
